export const formatDate = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
};

export const getDateObjectFromFullDateString = (date: string) => {
  return new Date(date.replace(/\s/, 'T'));
};
